import React from 'react'
import Router from '../../router';

// Components
import { PasswordRecoveryFormContainer } from '../../components/molecules/forms/PasswordRecoveryForm/container'
import { LanguageSelect } from '../../components/atoms/languageSelect'
import { ColorsContext } from '../../Context/ColorsContext'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

// Styles
import { LanguageContainer } from '../styles'


// Styles
import {
  Container,
  SectionLeft,
  SectionRight,
  ContainerForm,
  CustomButtonBack,
} from './styles'
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const PasswordRecovery = () => {

    const { openBackDrop, contentRender, colors } = React.useContext(ColorsContext);
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        !contentRender ? (
            <>
              <Backdrop
                sx={{ color:"#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={openBackDrop}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </>
        ) : (
            <Container>
                <SectionLeft imgUrl={`${Router.apiBaseUrl}${Router.appStaticAppearance}/bg_login.jpg`}>
                </SectionLeft>
                <SectionRight>
                    <Grid container style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <Grid item xs={3}>
                            <CustomButtonBack startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 13 }} />} onClick={() => navigate(Router.appLogin)}>
                                {t('login.stepper.back')}
                            </CustomButtonBack>
                        </Grid>
                        <Grid item xs={9}>
                            <LanguageContainer insideApp={false}><LanguageSelect insideApp={false}/></LanguageContainer>
                        </Grid>
                    </Grid>
                    <ContainerForm>
                        <PasswordRecoveryFormContainer colors={colors}/>
                    </ContainerForm>
                </SectionRight>
            </Container>
        )
    )
}
